/**
 * Ekselens brand palette helpers for Recharts.
 * Keeps every chart consistent with the brand and a11y-friendly.
 */
export const BRAND = {
  purple: "#7737F6",
  purpleLight: "#A179FA",
  purpleSoft: "#E9DEFE",
  black: "#0B0B0C",
  ink: "#111",
  grey: "#F2F2F3",
  greyMid: "#6B6B70",
  // Difference heatmap colours (improvement / unchanged / regression)
  green: "#1E9E5A",     // improvement
  amber: "#E0A52A",     // unchanged (per user instruction — not grey)
  red: "#D43A3A",       // regression
};

/** Distinct colour stops for compare-mode (up to 6 overlays). */
export const COMPARE_PALETTE = [
  "#7737F6", // brand
  "#0B7DCB", // blue
  "#1E9E5A", // green
  "#E0A52A", // amber
  "#D43A3A", // red
  "#6B6B70", // grey
];

/** Effort/impact to numeric for scatter axes. */
export const EFFORT_SCALE = { XS: 1, S: 2, M: 3, L: 4 };
export const IMPACT_SCALE = { low: 1, med: 2, high: 3 };

export const diffColour = (delta) => {
  if (delta >= 0.3) return BRAND.green;
  if (delta <= -0.3) return BRAND.red;
  return BRAND.amber;
};
